module.exports = __webpack_public_path__ + "img/logo-forbes.f277bec9.png";